export { ComponentLoader } from './component-loader.class';
export { ComponentLoaderFactory } from './component-loader.factory';
export { ContentRef } from './content-ref.class';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
